import { BidCategory } from "../constants";

export const CalcBidCategoryFromBidType = ({ bidType }) =>
  bidType === "ENERGY" ? BidCategory.ENERGY : BidCategory.FCAS; //simplified for now, can change to get from config endpoints
